/**
 * Configuration d'authentification
 * Permet de basculer entre Keycloak OAuth2 et user-service HMAC
 */

import { AuthProvider } from '@refinedev/core';
import { authProvider as userServiceAuthProvider } from './auth';
import { authKeycloakProvider } from './authKeycloak'; // OAuth2 Authorization Code + PKCE (sécurisé)

// Déterminer le mode d'authentification
const AUTH_MODE = import.meta.env.VITE_AUTH_MODE || 'keycloak';

// Log du mode pour debug
console.log(`🔐 Authentication mode: ${AUTH_MODE} (OAuth2 Authorization Code + PKCE)`);

// Exporter le bon authProvider selon le mode
export const authProvider: AuthProvider = AUTH_MODE === 'keycloak'
  ? authKeycloakProvider  // OAuth2 avec redirection sécurisée vers Keycloak
  : userServiceAuthProvider;

// Export nommés pour pouvoir importer explicitement un provider
export { userServiceAuthProvider, authKeycloakProvider };

// Info sur le mode actuel
export const authConfig = {
  mode: AUTH_MODE,
  isKeycloak: AUTH_MODE === 'keycloak',
  isUserService: AUTH_MODE === 'userservice',
};
